import React, { useEffect, useRef, useState } from 'react'

const ReCaptcha = ({sitekey, callback}) => {
    const reCaptchaRef = useRef(null);
    const [isRecaptchaLoaded, setIsRecaptchaLoaded] = useState(false);

    const onRecaptchaLoad = () => {
        setIsRecaptchaLoaded(true);
        console.log('Recaptcha loaded');
    }

    useEffect(() => {
        window.onRecaptchaLoad = onRecaptchaLoad;
        if (!window.grecaptcha) {
            const script = document.createElement('script');
            script.src = `https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoad&render=explicit`;
            script.async = true;
            script.defer = true;

            document.head.appendChild(script);
        }
        else if (window.grecaptcha && window.grecaptcha.render) {
            setIsRecaptchaLoaded(true);
        }

        return () => {
            window.onRecaptchaLoad = null;
            //if (script) {
            //    document.head.removeChild(script);
            //}
        };
    }, [])

    useEffect(() => {
        if (isRecaptchaLoaded) {
            window.grecaptcha.render(reCaptchaRef.current, {
                'sitekey': sitekey,
                'callback': callback
            });
        }
    }, [isRecaptchaLoaded])

    return (
        <div ref={reCaptchaRef}></div>
    )
}

export default ReCaptcha;